/** "3m ago" / "just now" / "never" — the staleness read on the device table. */
export function relativeTime(iso: string | null, now: number = Date.now()): string {
  if (!iso) return 'never';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return 'never';

  const seconds = Math.floor((now - then) / 1000);
  if (seconds < 0) return 'just now';
  if (seconds < 10) return 'just now';
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}

/** "1.2 MB" / "384 B" — session byte counters (backend sends bigint as string). */
export function formatBytes(value: string | number): string {
  const n = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(n) || n < 0) return '—';
  if (n < 1024) return `${n} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let v = n;
  let i = -1;
  do {
    v /= 1024;
    i++;
  } while (v >= 1024 && i < units.length - 1);
  return `${v >= 100 ? Math.round(v) : v.toFixed(1)} ${units[i]}`;
}

/** `2026-10-21 07:17:03` — an ISO timestamp in the operator's local time (pack log, downloads). */
export function formatAt(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

/**
 * `https://erp.dikonek.com` → `erp.dikonek.com`. The broker owns the public
 * hostname (only it knows the configured base domain), so the GUI displays
 * whatever the API returned rather than rebuilding it from a hardcoded suffix.
 */
export function hostOf(url: string): string {
  return url.replace(/^https?:\/\//, '').replace(/\/+$/, '');
}

/**
 * The command a user copies to reach a box — the GUI never opens a terminal (D5).
 * Includes `--user` because `dkn ssh` defaults to 'dikonek', which is wrong for
 * boxes with a different login (e.g. a Raspberry Pi's 'pi').
 */
export function sshCommandFor(deviceName: string, sshUser: string): string {
  return `dkn ssh ${deviceName} --user ${sshUser}`;
}
